import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";
import { useLang } from "../contexts/LangContext";

const FAQS_BY_LANG = {
  it: [
    { q: "Quanto tempo impiega la spedizione?", a: "In Italia 24-48h, Europa 3-5 giorni lavorativi. Tutte le spedizioni sono refrigerate e tracciate." },
    { q: "Come funzionano gli abbonamenti?", a: "Scegli la frequenza (settimanale/mensile), ricevi la box a casa e cancelli quando vuoi dal tuo account." },
    { q: "Posso rendere un prodotto?", a: "Prodotti sigillati non deperibili entro 14 giorni. Per deperibili, contattaci per un rimborso o sostituzione." },
    { q: "Come funziona l'AI per le ricette?", a: "Descrivi quello che vuoi, l'AI genera una ricetta autentica italiana e collega ogni ingrediente alla box in vendita più adatta." },
    { q: "Siete un marketplace B2B anche?", a: "Sì, abbiamo un portale B2B riservato a operatori verificati (broker, importatori, Ho.Re.Ca., GDO) con prezzi per cartone/pallet." },
  ],
  en: [
    { q: "How long does shipping take?", a: "Italy 24-48h, Europe 3-5 business days. All shipments are refrigerated and tracked." },
    { q: "How do subscriptions work?", a: "Choose your frequency (weekly/monthly), receive the box at home and cancel anytime from your account." },
    { q: "Can I return a product?", a: "Sealed non-perishable products within 14 days. For perishables, contact us for refund or replacement." },
    { q: "How does the AI recipe feature work?", a: "Describe what you want, the AI generates an authentic Italian recipe and links every ingredient to the most suitable box on sale." },
    { q: "Are you also a B2B marketplace?", a: "Yes, we have a B2B portal reserved for verified operators (brokers, importers, Ho.Re.Ca., retail) with carton/pallet pricing." },
  ],
};

export default function Supporto() {
  const { t, lang } = useLang();
  const faqs = FAQS_BY_LANG[lang] || FAQS_BY_LANG.en;

  return (
    <div data-testid="supporto-page" className="container-xl py-12 max-w-3xl">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">{t("nav.support")}</div>
      <h1 className="editorial-heading text-5xl md:text-6xl">{t("support.title")}</h1>
      <p className="text-muted-foreground text-lg mt-3">{t("support.subtitle")}</p>
      <Accordion type="single" collapsible className="mt-10">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`}>
            <AccordionTrigger data-testid={`faq-${i}`} className="text-left editorial-heading text-xl">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="mt-10 bg-[hsl(var(--muted))] rounded-sm p-6">
        <div className="editorial-heading text-2xl">{t("support.contact_email")} / {t("support.contact_phone")}</div>
        <div className="mt-3 text-sm space-y-1">
          <div>{t("support.email")}: support@amazonico3000.com</div>
          <div>{t("support.phone")}: +39 02 1234 5678</div>
          <div>{t("support.hours")}</div>
        </div>
      </div>
    </div>
  );
}
